import { fork, call, put, all, takeLatest } from "redux-saga/effects";
import axios from "axios";
import asyncInterface from "../../../asyncInterface";
import * as actionTypes from './actionTypes'

export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.recommendGrant.fetchAccountData(fetchPayload);
}

export function* transactionDataFetch(data) {
  yield put({ type: actionTypes.fetchTransactionDataLoadingType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.fetchTransactionDataSuccessType,
      payload: { data: response.data, tabType: data.tabType }
    });
  } catch (error) { }
}

export function* balanceDataFetch(data) {
  yield put({ type: actionTypes.fetchBalanceLoadingType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.fetchBalanceSuccessType,
      payload: response.data
    });
  } catch (error) { }
}

export function* feeAndExpensesFetch(data) {
  yield put({ type: actionTypes.fetchFeeLoadingType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.fetchFeeSuccessType,
      payload: response.data
    });
  } catch (error) { }
}

export function* feeContentFetch(data) {
  yield put({ type: actionTypes.fetchFeeContentLoadingType });
  try {
    const response = yield axios({
      method: 'GET',
      url: data.url,
      page: 'transactionSummary',
      headers: {
        'Access-Control-Allow-Origin': '*'
      }
    });
    yield put({
      type: actionTypes.fetchFeeContentSuccessType,
      payload: response.data
    });
  } catch (error) {}
}

export function* transactionTabDataFetch(data) {
  let tabType = data.tabType;
  yield put({ type: actionTypes.fetchTransactionTabLoadingType, payload: tabType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.fetchTransactionTabSuccessType,
      payload: { data: response.data, tabType: tabType }
    });
  } catch (error) { }
}

export function* otherTransactionDetails(action) {;
  yield put({ type: actionTypes.fetchOtherTransactionLoadingType });
  try {
    const payload = yield call(fetchAccountData, action.payload);
    yield put({ type: actionTypes.fetchOtherTransactionSuccessType, payload })
  } catch (error) {
    yield put({ type: actionTypes.fetchOtherTransactionErrorType, error })
  }
}

export function* fetchTransactionSummaryWorker(fetchPayload) {
  yield all([
    fork(transactionDataFetch, fetchPayload.payload[0]),
    fork(balanceDataFetch, fetchPayload.payload[1]),
    fork(feeAndExpensesFetch, fetchPayload.payload[2]),
    fork(feeContentFetch, fetchPayload.payload[3]),
  ]);
}

export function* fetchTransactionSummaryWatcher() {
  yield takeLatest(actionTypes.fetchTransactionDataType, fetchTransactionSummaryWorker);
}

export function* fetchTransactionSummaryTabWorker(fetchPayload) {
  yield all([
    fork(transactionTabDataFetch, fetchPayload.payload[0]),
  ]);
}

export function* fetchTransactionSummaryTabWatcher() {
  yield takeLatest(actionTypes.fetchTransactionTabDataType, fetchTransactionSummaryTabWorker);
  yield takeLatest(actionTypes.fetchOtherTransactionType, otherTransactionDetails);
}

export default function* TransactionSummary() {
  yield all([fork(fetchTransactionSummaryWatcher)]);
  yield all([fork(fetchTransactionSummaryTabWatcher)]);
}
